export const MAX_MACHINE_PHOTOS = 4

export function machinePhotoLimitMessage(currentCount: number): string {
  const remaining = Math.max(0, MAX_MACHINE_PHOTOS - currentCount)
  return `Esta máquina pode possuir no máximo ${MAX_MACHINE_PHOTOS} fotos. Você ainda pode adicionar ${remaining} ${remaining === 1 ? 'foto' : 'fotos'}.`
}

export function machinePhotoSelectionLimitMessage(currentCount: number): string {
  const remaining = Math.max(0, MAX_MACHINE_PHOTOS - currentCount)
  return `Esta máquina já possui ${currentCount} ${currentCount === 1 ? 'foto' : 'fotos'}. Você pode adicionar somente mais ${remaining}.`
}
